import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

const ScoutingSummaryCards = ({ totalPlayers = 0, totalWatchedMatches = 0, totalNotes = 0, topPlayer, nextMatch, players = [] }) => {
  const { t, i18n } = useTranslation("scouting");
  const [playerIndex, setPlayerIndex] = useState(0);
  const sortedPlayers = useMemo(
    () => [...players].sort((a, b) => (b.stats?.matches || 0) - (a.stats?.matches || 0)),
    [players]
  );
  const index = sortedPlayers.length ? playerIndex % sortedPlayers.length : 0;
  const currentPlayer = sortedPlayers[index] || topPlayer;
  const parsedDate = nextMatch?.date ? new Date(nextMatch.date) : null;
  const dateLabel = parsedDate && !Number.isNaN(parsedDate.getTime())
    ? parsedDate.toLocaleDateString(i18n.language, { day: "numeric", month: "long", year: "numeric" })
    : t("components.summaryCards.dateUnknown");

  return (
    <div className="sc-overview">
      <dl className="sc-summary">
        {[
          ["followedPlayers", totalPlayers],
          ["watchedMatches", totalWatchedMatches],
          ["recordedNotes", totalNotes],
        ].map(([key, value]) => (
          <div key={key}>
            <dt>{t(`components.summaryCards.${key}`)}</dt>
            <dd>{value.toLocaleString(i18n.language)}</dd>
          </div>
        ))}
      </dl>
      <div className="sc-highlights">
        <article className="sc-highlight">
          <div className="sc-highlight-heading">
            <h3>{t("components.summaryCards.nextMatch")}</h3>
            <span className="sc-date">{dateLabel}</span>
          </div>
          <strong>{nextMatch?.label || t("components.summaryCards.noData")}</strong>
          <p>{nextMatch?.competition || t("agenda.noUpcoming")}</p>
        </article>
        <article className="sc-highlight">
          <div className="sc-highlight-heading">
            <h3>{t("components.summaryCards.topPlayer")}</h3>
            {sortedPlayers.length > 1 && (
              <div className="sc-carousel">
                <IconButton
                  aria-label={t("workspace.previousPlayer")}
                  onClick={() => setPlayerIndex((index + sortedPlayers.length - 1) % sortedPlayers.length)}
                >
                  <ChevronLeft />
                </IconButton>
                <span>{index + 1} / {sortedPlayers.length}</span>
                <IconButton aria-label={t("workspace.nextPlayer")} onClick={() => setPlayerIndex((index + 1) % sortedPlayers.length)}>
                  <ChevronRight />
                </IconButton>
              </div>
            )}
          </div>
          <strong>{currentPlayer?.name || t("components.summaryCards.noData")}</strong>
          <p>{currentPlayer?.team || t("components.comparison.noTeam")}</p>
          {currentPlayer && (
            <dl className="sc-inline-stats">
              {["matches", "starters", "goals"].map((key) => (
                <div key={key}>
                  <dt>{t(`components.trends.metric.${key}`)}</dt>
                  <dd>{currentPlayer.stats?.[key] ?? 0}</dd>
                </div>
              ))}
            </dl>
          )}
        </article>
      </div>
    </div>
  );
};

export default ScoutingSummaryCards;
